import { put, takeEvery, call } from "redux-saga/effects";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
    FETCH_GST_INIT_ACTION,
    FETCH_GST_SUCCESS_ACTION,
    FETCH_GST_FAIL_ACTION,
    ADD_GST_INIT_ACTION,
    ADD_GST_SUCCESS_ACTION,
    ADD_GST_FAIL_ACTION,
    UPDATE_GST_STATUS_INIT_ACTION,
    UPDATE_GST_STATUS_SUCCESS_ACTION,
    UPDATE_GST_STATUS_FAIL_ACTION,
    EDIT_GST_INIT_ACTION,
    EDIT_GST_SUCCESS_ACTION,
    EDIT_GST_FAIL_ACTION,
} from "./action";

function* fetchGst(action) {
    const token = localStorage.getItem("token");
    let pageno = action.value === undefined ? 1 : action.value;
    try {
        const res = yield fetch(`${appConfig.ip}/gstMaster?limit=10&page=` + pageno, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        if (!res.ok) {
            let errJSON = {};
            try {
                errJSON = yield res.json();
            } catch { }
            throw Object.assign(res, errJSON);
        } else {
            const resJSON = yield res.json();
            yield put({
                type: FETCH_GST_SUCCESS_ACTION,
                payload: resJSON,
            });
        }
    } catch (err) {
        yield put({ type: FETCH_GST_FAIL_ACTION, error: err });
    }
}

function* addGst(action) {
    try {
        const token = localStorage.getItem("token");
        const data = {
            label: action.value.label,
            taxPercentage: Number(action.value.taxPercentage),
            status: "active", // initially active
        };

        const res = yield fetch(`${appConfig.ip}/gstMaster`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });

        if (!res.ok) {
            let errJSON = {};
            try {
                errJSON = yield res.json();
            } catch { }
            throw Object.assign(res, errJSON);
        } else {
            const resJSON = yield res.json();
            yield put({ type: FETCH_GST_INIT_ACTION, value: 1 });
            yield put({
                type: ADD_GST_SUCCESS_ACTION,
                payload: resJSON,
            });
            yield toast.success("GST added successfully", {
                autoClose: 3000,
            });
        }
    } catch (err) {
        yield put({
            type: ADD_GST_FAIL_ACTION,
            error: err,
        });
        yield toast.error(err.message || "Failed to add GST", {
            autoClose: 3000,
        });
    }
}

function* updateGstStatus(action) {
    try {
        const token = localStorage.getItem("token");
        const data = {
            ...action.item,
            status: action.status,
        };

        const res = yield fetch(`${appConfig.ip}/gstMaster/` + action.item.id, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });

        if (!res.ok) {
            let errJSON = {};
            try {
                errJSON = yield res.json();
            } catch { }
            throw Object.assign(res, errJSON);
        } else {
            const resJSON = yield res.json();
            yield put({ type: FETCH_GST_INIT_ACTION });
            yield put({
                type: UPDATE_GST_STATUS_SUCCESS_ACTION,
                payload: resJSON,
            });
            yield toast.success("Status updated successfully", {
                autoClose: 3000,
            });
        }
    } catch (err) {
        yield put({
            type: UPDATE_GST_STATUS_FAIL_ACTION,
            error: err,
        });
        yield toast.error(err.message || "Failed to update status", {
            autoClose: 3000,
        });
    }
}

function* editGst(action) {
    try {
        const token = localStorage.getItem("token");
        const data = {
            label: action.value.label,
            taxPercentage: Number(action.value.taxPercentage),
        };

        const res = yield fetch(`${appConfig.ip}/gstMaster/` + action.value.id, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });

        if (!res.ok) {
            let errJSON = {};
            try {
                errJSON = yield res.json();
            } catch { }
            throw Object.assign(res, errJSON);
        } else {
            const resJSON = yield res.json();
            yield put({ type: FETCH_GST_INIT_ACTION });
            yield put({
                type: EDIT_GST_SUCCESS_ACTION,
                payload: resJSON,
            });
            yield toast.success("GST updated successfully", {
                autoClose: 3000,
            });
        }
    } catch (err) {
        yield put({
            type: EDIT_GST_FAIL_ACTION,
            error: err,
        });
        yield toast.error(err.message || "Failed to update GST", {
            autoClose: 3000,
        });
    }
}

export function* gstMasterActionWatcher() {
    yield takeEvery(FETCH_GST_INIT_ACTION, fetchGst);
    yield takeEvery(ADD_GST_INIT_ACTION, addGst);
    yield takeEvery(UPDATE_GST_STATUS_INIT_ACTION, updateGstStatus);
    yield takeEvery(EDIT_GST_INIT_ACTION, editGst);
}
